import CoachPairSelector from './CoachPairSelector';

export default CoachPairSelector;
